import { ContactPhotoResponse } from '../../../../../../../services/marketplace/generated/kubb/models/ContactPhotoResponse';
import { uploadPresentation } from '../utils';
import DocumentsPanelRow, { ReplaceFileButton, ViewFileButton } from './DocumentsPanelRow';

type RequiredPhotoRowProps = {
  photo: ContactPhotoResponse;
  isReplacing: boolean;
  onReplace: () => void;
};

const RequiredPhotoRow = ({ photo, isReplacing, onReplace }: RequiredPhotoRowProps) => {
  const presentation = uploadPresentation('photo', photo.photoType);

  return (
    <DocumentsPanelRow
      thumbnailUrl={photo.url}
      fallbackIcon={presentation.icon}
      name={presentation.label}
      actions={
        <>
          <ViewFileButton url={photo.url} />
          {photo.photoType !== 'odometer' && (
            <ReplaceFileButton isReplacing={isReplacing} onReplace={onReplace} />
          )}
        </>
      }
    />
  );
};

export default RequiredPhotoRow;
